<template>
    <app-layout title="Aanvragen in wacht">
        <template #header>
            <page-title title="Aanvragen in wacht" />
        </template>

        <template #pageContent>
            <TableSearch tableId="overview-pending-requests" :values="requests" class="w-1/4" placeholder="Zoeken"/>

            <Table id="overview-pending-requests" :values="requests" class="mt-4 w-full">
                <thead>
                    <tr>
                        <Th id="webshop_id">Webshop id</Th>
                        <Th id="request_type.type">Type</Th>
                        <Th id="reference">Bestelling</Th>
                        <Th id="external_reference">Dossiernr.</Th>
                        <Th id="customer">Klantnaam</Th>
                        <Th id="mail_contact">E-mailadres klant</Th>
                        <Th id="broker.person">Makelaar</Th>
                        <Th id="broker.mail">E-mailadres makelaar</Th>
                        <Th id="inspection_address">Inspectie adres</Th>
                        <Th id="created_at">Datum toegevoegd</Th>
                        <Th id="checked_at">Datum laatst gecontroleerd</Th>
                        <Th id="payment_reminder_send_at">Datum betaalreminder verstuurd</Th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(request, key) in state.sortedValues['overview-pending-requests']" :key="key">
                        <Td>{{ request.webshop_id }}</Td>
                        <Td>{{ request.request_type.type }}</Td>
                        <Td>{{ request.reference }}</Td>
                        <Td>
                            <template v-if="request.external_reference">
                                {{ request.external_reference }}
                            </template>
                        </Td>
                        <Td>
                            <template v-if="request.customer">
                                {{ request.customer }}
                            </template>
                        </Td>
                        <Td>
                            <template v-if="request.mail_contact">
                                <a :href="'mailto:' + request.mail_contact">
                                    {{ request.mail_contact }}
                                </a>
                            </template>
                        </Td>
                        <Td>
                            <template v-if="request.broker">
                                {{ request.broker.person }}
                            </template>
                        </Td>
                        <Td>
                            <template v-if="request.broker">
                                <a :href="'mailto:' + request.broker.mail">
                                    {{ request.broker.mail }}
                                </a>
                            </template>
                        </Td>
                        <Td>
                            <template v-if="request.inspection_address">
                                {{ request.inspection_address }}<br>
                                {{ request.inspection_postal_code }} {{ request.inspection_place }}
                            </template>
                        </Td>
                        <Td>
                            <template v-if="request.created_at">
                                {{ moment(request.created_at).format('DD/MM/YYYY HH:mm') }}
                            </template>
                        </Td>
                        <Td>
                            <template v-if="request.checked_at">
                                {{ moment(request.checked_at).format('DD/MM/YYYY HH:mm') }}
                            </template>
                        </Td>
                        <Td>
                            <template v-if="request.payment_reminder_send_at">
                                {{ moment(request.payment_reminder_send_at).format('DD/MM/YYYY HH:mm') }}
                            </template>
                        </Td>
                    </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Modal from '@/Components/Modal.vue'

import store from '@/store'
import moment from "moment"
import { Link } from '@inertiajs/inertia-vue3'

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Modal,
        Link,
    },
    props: [
        'requests',
    ],
    setup (props){

        return {
            state: store.state,
            ...store,
        }
    },
    created: function () {
        this.moment = moment;
    },
}

</script>
